<script>
  import SubscriptionSelectionCard from './SubscriptionSelectionCard.svelte';

  export let data, cards, componentInformationKeys;

  const {
    currentActiveSubscription,
    isCustomerInactive,
    featuredProductMetadataId,
    countryIso,
    language,
    showDarkBackground,
  } = data;

  const oneSubscriptionCard = data.firstRow.productGroups.length <= 1;
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  .subscription-area {
    display: grid;
    grid-gap: 0 spacing(4);
    justify-content: center;

    &-one-card {
      @include mq($from: desktop) {
        margin-block-start: 9.5rem;
      }
    }

    &-one-card-dark {
      @include mq($from: desktop) {
        margin-block-start: 0;
      }
    }

    @include mq($until: desktop) {
      align-items: center;
    }
    @include mq($from: desktop) {
      grid-template-rows: repeat(7, auto);
      grid-auto-flow: column;
    }
  }
</style>

<div
  class="subscription-area"
  class:subscription-area-one-card={oneSubscriptionCard}
  class:subscription-area-one-card-dark={oneSubscriptionCard && showDarkBackground}
>
  {#each data.firstRow.productGroups as subscription, i}
    <SubscriptionSelectionCard
      subscription={{
        ...subscription,
        currentActiveSubscription,
        isCustomerInactive,
        featuredProductMetadataId,
        countryIso,
        language,
      }}
      {componentInformationKeys}
      {showDarkBackground}
      bind:card={cards[i]}
    />
  {/each}
</div>
